/* eslint-disable */
import * as React from 'react';
import map from 'lodash/map';
import iEmpty from 'lodash/isEmpty';
import axios from 'axios';
import { getCurrentEnv } from '@sfly/uig-current-environment-util';
import Logger from './Logger';
import { DC_SERVICE_API_KEYS } from '../constants/CommonConstants';
const loggerInstance = new Logger('Common utils', 'Sfly-Calendar-Responsive');

export class CommonUtils {

    constructor(useMocks = false, dispatch = undefined) {
        this.useMocks = useMocks;
        this.dispatch = dispatch;
        this.config = {
            headers: {
                'SFLY-ApiKey': this.getEnvPrefix() !== '' ? DC_SERVICE_API_KEYS.NON_PROD : DC_SERVICE_API_KEYS.PROD
            }
        };
    }

    // This will fetch content from provided url and update the store state using provided action type.
    // dc_url: generated path to dc based on env.
    // componentType: for which component you're fetching the details.
    // actionTypeMapping: actionTypeMapping object contains actionType and isConversionRequired. actionType is a update function related to the content we want to update/fetch details for 
    // and isConversionRequired is to tell dispatchAction method whether to perform JSON conversion or not.
    fetchContentDetails(dc_url, componentType, actionTypeMapping) {
        return new Promise((resolve, reject) => {
            const errorText = componentType.replace(/-/g, ' ');

            this.makeGetCall(dc_url)
                .then((response) => {
                    this.dispatchAction(actionTypeMapping, response.data, errorText + ' data not found');
                    resolve();
                }, (error) => {
                    loggerInstance.error('Failed to retrieve ' + errorText + ' details from endpoint. ', error);
                    console.error('Failed to retrieve ' + errorText + ' details from endpoint. ', error);
                    reject();
                });
        });
    }

    // This method make a POST call using Axios and return a Promise.
    // url: URL/API to make a POST call.
    // errorText: specific error text to print in the logger/console.
    // body: required data by URL/API to send along with request 
    // config: extra configs like headers, etc.
    async makePostCall(url, errorText, body = {}, config = {}) {
        return axios.post(url, body, config)
            .then((res) => {
                return res;
            }, (err) => {
                loggerInstance.error(errorText, err);
                console.error(errorText, err);
                return err;
            })
    }

    // This method make a GET call using Axios and return a Promise.
    // url: URL/API to make a GET call.
    // errorText: specific error text to print in the logger/console.
    // config: extra configs like headers, etc.
    async makeGetCall(url, errorText, config = {}) {
        return axios.get(url, config)
            .then((res) => {
                return res;
            }, (err) => {
                loggerInstance.error(errorText, err);
                console.error(errorText, err);
                return err;
            });
    }

    // fetch the pricing details from /productprice/get_minprice_with_discountinfo api for provided skus  
    // and return the promise with received response.
    fetchPricing(skuMappingDetails) {
        const url = '//api2.'+ this.getEnvPrefix() +'shutterfly.com/v1/pricing-orchestration/producttypeprice/v1/pricing-with-discount-info';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SFLY-ApiKey': this.getEnvPrefix() !== '' ? 'T9euP4AI4hSqzqzNHVNeNW0c3imkw0pb' : 'OIMmm2kTGy2gS1OEjrhsGAuumkHcWP0F'
            }
        };
        
        return this.makePostCall(url, "Something went wrong! Unable to fetch pricing. ", skuMappingDetails, config);
    }

    // Check if the passed object is an array with length greater than 0 (zero) or not
    isValidArray(obj) {
        return Array.isArray(obj) && obj.length > 0;
    }

    // Check if the passed object is a valid object or not
    isValidObject(obj) {
        return null !== obj && typeof obj === 'object';
    }

    // This method generates a url, which is used for fetching the data in batch call.
    getBatchURL(jsonObj, url) {
        let batchURL = url && url !== "" ? url : "//api2." + this.getEnvPrefix() + "shutterfly.com" + "/v1/services-dynamic-content/v1/dynamic-content/batch?contentSpaces=";
        
        Object.keys(jsonObj).map((key, index) => {
            if(key !== "id") {
                if(this.isValidArray(jsonObj[key])) {
                    jsonObj[key].map((obj) => {
                        if(this.isValidObject(obj)) {
                            batchURL = this.getBatchURL(obj, batchURL);
                        } else {
                            batchURL += "," + obj; 
                        }
                    });
                } else {
                    batchURL += !url && index === 0 ? jsonObj[key] : "," + jsonObj[key];
                }
            } else {
                batchURL += "," + jsonObj[index];
            }
        });
        return batchURL;
    }

    // This method passes data to dispatch action to update related values in store
    passDataToDispatchAction(key, data, obj, actionTypesMapping) {
        let fetchedData = this.isValidObject(obj) ? data[obj[key]] : data[obj];
        
        if (fetchedData && fetchedData !== "") {
            this.dispatchAction(actionTypesMapping[key], fetchedData, key.replace(/_/g, " ") + " related data not found", obj.id);
        } else {
            loggerInstance.warn(key.replace(/_/g, " ") + " details are not available for this page or not found");
            console.warn(key.replace(/_/g, " ") + " details are not available for this page or not found");
        }
    }

    createDynamicContentsMap = dynamicContents => dynamicContents.reduce((acc, element)  =>
        ({...acc, [element.contentSpace]: element.dynamicContent}), {});

    // This method fetch the data in batch call and pass the data to passDataToDispatchAction method
    fetchDataInBatch(batchConfig, actionTypesMapping, baseURL) {
        if(this.useMocks) {
            this.fetchMockData(batchConfig, actionTypesMapping, baseURL);
        } else {
            this.makeGetCall(this.getBatchURL(batchConfig), 'Failed to retrieve dc batch data from endpoint.', this.config)
            .then((response) => {
                let data = this.createDynamicContentsMap(response.data.dynamicContents)
                Object.keys(batchConfig).map((key) => {
                    if(this.isValidArray(batchConfig[key])) {
                        let arrObj = batchConfig[key];
                        arrObj.map((obj) => {
                            if(this.isValidObject(obj)) {
                                Object.keys(obj).map((subKey) => {
                                    if(subKey !== 'id') {
                                        this.passDataToDispatchAction(subKey, data, obj, actionTypesMapping);
                                    }
                                });
                            } else {
                                this.passDataToDispatchAction(key, data, obj, actionTypesMapping);
                            }
                        });
                    } else {
                        this.passDataToDispatchAction(key, data, batchConfig, actionTypesMapping);
                    }
                });
            }, (error) => {
                loggerInstance.error('Failed to retrieve ' + errorText + ' details from endpoint. ', error);
                console.error('Failed to retrieve ' + errorText + ' details from endpoint. ', error);
                reject();
            });
        }
    }

    // This method is used for fetching mock data for local server.
    fetchMockData(batchConfig, actionTypesMapping, baseURL) {
        Object.keys(batchConfig).map((key) => {
            if(this.isValidArray(batchConfig[key])) {
                let arrObj = batchConfig[key];
                arrObj.map((obj) => {
                    if(this.isValidObject(obj)) {
                        Object.keys(obj).map((subKey) => {
                            if(subKey !== 'id') {
                                this.fetchContentDetails(baseURL + obj[subKey], subKey, actionTypesMapping[subKey], obj.id);
                            }
                        });
                    } else {
                        this.fetchContentDetails(baseURL + obj, key, actionTypesMapping[key], obj.id);
                    }
                });
            } else {
                this.fetchContentDetails(baseURL + batchConfig[key], key, actionTypesMapping[key]);
            }
        });
    }

    // This method is used to update states in the store.
    dispatchAction(actionTypeMapping, data, errorText = undefined) {
        if(data) {
            this.dispatch(actionTypeMapping.actionType(actionTypeMapping.isConversionRequired ? this.convertToJSON(data) : data));
        } else {
            loggerInstance.warn(errorText);
            console.warn(errorText);
        }
    }

    // used to perform null check on dynamic contents which are to be inserted
    // using dangerouslySetInnerHTML
    getDynamicContent(text) {
        if (text && text !== '') {
            return { __html: text };
        }
    }

    // this will return env prefix
    getEnvPrefix() {
        const env = getCurrentEnv();
        if(env === 'production') {
            return '';
        }
        return env + '.';
    }

    getNodeAttributs(node) {
        const attributes = {};
        if(node && !iEmpty(node.attributes)) {
            map(node.attributes, (attr) => {
                if(attr.nodeName === 'href') {
                    attributes[attr.nodeName] = attr.nodeValue;
                } else if(attr.nodeName === 'class') {
                    attributes['className'] = attr.nodeValue;
                }
            });
        }

        return attributes;
    }

    // This method scans a string (parsed/obtained from JSON) for HTML elements; creates and returns a renderable element.
    // One can use this method whenever a string needs to be treated as a HTML/DOM element.
    scanForHTMLElement(parsedString, parsedChildNodes) {
        if (parsedString && parsedString !== '') {
            const regex = /<[a-z][\s\S]*>/i;

            if (regex.test(parsedString)) {
                let childNodes;
                if (!parsedChildNodes) {
                    const domParser = new DOMParser();
                    childNodes = domParser.parseFromString(parsedString, 'text/html').body.childNodes;
                } else {
                    childNodes = parsedChildNodes;
                }
                
                return map(childNodes, (node) => {
                    if(node.nodeName === "#text" || !node.innerHTML) {
                        return node.nodeValue;
                    } else {
                        return React.createElement(
                            node.localName,
                            this.getNodeAttributs(node),
                            node.childNodes && node.childNodes.length > 0 ?
                            this.scanForHTMLElement(parsedString, node.childNodes) :
                            node.innerText || ''
                        );
                    }
                });
            }

            return parsedString;
        }
    }


    // converts the JSON string to JSON object fetched from comet
    convertToJSON(response , errorText)  {
        //strip out the wrapper added by comet
        let stringJSON  = response.replace('<!-- HTML Content Wrapper -->', '');
        stringJSON = stringJSON.replace('<!-- /HTML Content Wrapper -->', '');
        //convert the string to JSON object
        try {
            return JSON.parse(stringJSON);
        } catch (e) {
            loggerInstance.error('Unable to create a JSON object using the string provided ' + errorText || '', e);
            console.error('Unable to create a JSON object using the string provided ' + errorText || '', e);
            return undefined;
        }
    }

    // This method performs the null/undefined and empty check on response data
    // and returns the pricing details if present else return blank array [].
    getPricingDetailsObject(responseData) {
        if (responseData && responseData.productDisplaySummary 
                && responseData.productDisplaySummary.length > 0) {
            return responseData.productDisplaySummary;
        }

        return [];
    }

    // It will eliminate objects with blank types or empty or invalid skus array 
    // and return the resultant array
    getPricingRequestBody(responseData) {
        let data = this.convertToJSON(responseData, "Invalid product sku mapping details.");
        let validProducts = [];

        if(data && data.products && this.isValidArray(data.products)) {
            data.products.map((product) => {
                if(product.type !== '' 
                    && this.isValidArray(product.skus) 
                    && product.skus.length > 0) {
                    validProducts.push(product);
                } else {
                    loggerInstance.error("did not receive proper type/skuList for product. Have skipped that product from request. ", JSON.stringify(product));
                    console.error("did not receive proper type/skuList for product. Have skipped that product from request. ", JSON.stringify(product));
                }
            });
            
            data.products = validProducts;
        }
        return data;
    }
}
